import React from "react";
import Error from './Error';
import { useNavigate, useParams } from "react-router-dom";
import { Helmet } from 'react-helmet';

import "./Finish.css";

function Finish() {
    let navigate = useNavigate();
    let params = useParams();
    let level_number = params.levelNumber;
    const course_type = params.course;

    // Map course slugs to display names and max levels
    const COURSE_INFO = {
        "python": ["Python", 11],
        "python-legacy": ["Python Legacy", 5],
        "web-development": ["Web Development", 3],
        "apis-with-python": ["APIs with Python", 6],
    };

    const host = (process.env.NODE_ENV === 'development') ? 'http://localhost:8080' : '';
    const url = `${host}/api/certificate/${course_type}/${level_number}`;

    if (level_number > COURSE_INFO[course_type][1]) {
        return (<Error />)
    } else {
        return (
            <div>

                <Helmet>
                    <title>Level {level_number} Finish | Mission Encodeable</title>
                </Helmet>

                <section className="finish-header">
                    <h1>Congratulations on completing {COURSE_INFO[course_type][0]} Level {level_number}!</h1>
                </section>

                <section className="finish_certificate_download">
                    <h3>Download your certificate</h3>
                    <div className="form_wrapper">
                        <div className="finish_form">
                            <form action={url} method="get" autoComplete="new-off" id="certificate-search-form">
                                <label htmlFor="for">Your name:</label>
                                <input type="text" id="for" name="for" data-lpignore="true" required />
                                <button type="submit" className="btn_orange_fill">Download</button>
                                <p className="dp_info">Please note your name and the PDF certificate will not be saved on our systems. Your name must be in English / European letters.</p>
                            </form>
                        </div>
                    </div>
                </section>

                {level_number < COURSE_INFO[course_type][1] && <div className="start-section">
                    <h2>Ready to start {COURSE_INFO[course_type][0]} Level {parseInt(level_number) + 1}?</h2>
                    <button onClick={() => { navigate(`/${course_type}/level/${parseInt(level_number) + 1}`); }} className="btn_green_outline">Start level</button>
                </div>
                }


                <section className="end_of_level_survey">

                    <div className="end_of_level_survey_text">
                        <h3>Share your feedback</h3>
                        <p>Let us know what you thought of this level by filling in our short feedback survey.</p>
                    </div>

                    <a className="survey_button" href="https://tally.so/r/wajzRE" target="_blank" rel="noreferrer"><button className="btn_orange_fill">Take the survey</button></a>
                </section>


            </div>
        )
    }
}

export default Finish;
